// extracted by mini-css-extract-plugin
export default {"content":"LinkListAccordion__content___aYl6H"};